export default __webpack_public_path__ + "files/media/cal-md.37dc8ca6.png";